import React from "react";
import Logo from "./Logo";
import { CONTACT } from "../lib/siteData";
import { Linkedin, Instagram, Facebook, Mail, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-ink text-ivory mt-24 sm:mt-32"
    >
      <div className="container-prose py-16 sm:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <Logo invert />
            <p className="mt-6 max-w-md body-prose text-ivory/75 text-base sm:text-lg">
              Educator · Author · Trainer · Innovator · Consultant.
              Bridging classroom reality with world-class research — for the next generation of teachers.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="overline text-ivory/60">Reach</p>
            <div className="mt-4 space-y-3 text-[15px] body-prose">
              <a
                href={`mailto:${CONTACT.email}`}
                data-testid="footer-email"
                className="flex items-center gap-3 text-ivory/85 hover:text-ivory transition-colors"
              >
                <Mail size={15} className="text-forest" />
                {CONTACT.email}
              </a>
              <div className="flex items-center gap-3 text-ivory/85">
                <MapPin size={15} className="text-forest" />
                {CONTACT.city}
              </div>
            </div>
          </div>

          <div className="md:col-span-4">
            <p className="overline text-ivory/60">Elsewhere</p>
            <div className="mt-4 flex items-center gap-3">
              <SocialLink href={CONTACT.linkedin} label="LinkedIn" testid="footer-linkedin">
                <Linkedin size={16} />
              </SocialLink>
              <SocialLink href={CONTACT.instagram} label="Instagram" testid="footer-instagram">
                <Instagram size={16} />
              </SocialLink>
              <SocialLink href={CONTACT.facebook} label="Facebook" testid="footer-facebook">
                <Facebook size={16} />
              </SocialLink>
            </div>
            <p className="mt-8 text-[13px] text-ivory/50 body-prose">
              For speaking, training & consulting enquiries please use the contact form.
            </p>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-ivory/15 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-[12px] text-ivory/55 uppercase tracking-[0.18em]">
          <p>© {new Date().getFullYear()} Karamjeet Sodhi. All rights reserved.</p>
          <a href="/admin" data-testid="footer-admin-link" className="hover:text-ivory transition-colors">
            Admin
          </a>
        </div>
      </div>
    </footer>
  );
}

function SocialLink({ href, label, testid, children }) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={label}
      data-testid={testid}
      className="inline-flex items-center justify-center h-10 w-10 border border-ivory/20 hover:bg-forest hover:border-forest transition-all"
    >
      {children}
    </a>
  );
}
